import { IonPage } from "@ionic/react";
import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { exportComponentAsPNG } from "react-component-export-image";
import { useParams } from "react-router-dom";
import auth from "../../utils/auth";

const Certificate = (props) => {
	const certificateRef = useRef(null);
	const [courseName, setCourseName] = useState("");
	const [percentage, setPercentage] = useState(0);
	const params = useParams();
	const config = {
		headers: {
			"Content-Type": "application/json",
			"x-auth-token": auth.getToken(),
		},
	};
	const handleDownload = () => {
		exportComponentAsPNG(certificateRef, {
			fileName: "certificate",
		});
	};

	useEffect(() => {
		axios
			.get(`/progress/${params.courseID}/certificate`, config)
			.then((res) => {
				console.log(res.data);
				setCourseName(res.data.courseName);
				setPercentage(res.data.percentage);
			})
			.catch((err) => console.log(err));
	}, []);
	return (
		<IonPage>
			<div className="certificate-root">
				<div className="certificate-wrapper" ref={certificateRef}>
					<p className="certificate-name">{auth.getUserInfo().fullName}</p>
					<p className="certificate-desc">
						FOR SUCCESSFULLY COMPLETING THE COURSE - {`${courseName}`} WITH{" "}
						{`${percentage}%`} SCORE
					</p>
				</div>
				<br />
				<button className="send-otp download" onClick={() => handleDownload()}>
					Download Certificate
				</button>
			</div>
		</IonPage>
	);
};

export default Certificate;
